import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ArchwizardModule } from 'ng2-archwizard';
import { HotelManagementRoutingModule } from './hotel-management-routing.module';
import { SharedModule } from '../../../../../shared/shared.module';
import { HotelBrandComponent } from './hotel-brand/hotel-brand.component';
import { HotelsListComponent } from './hotels-list/hotels-list.component';
import { HotelBrandAddComponent } from './hotel-brand-add/hotel-brand-add.component';
import { HotelsAddComponent } from './hotels-add/hotels-add.component';
import { HotelManagementService } from '../../../../../shared/_services/hotel-management.service';
import { LoyaltyService } from '../../../../../shared/_services/loyalty.service';
import { HotelBrandWizardComponent } from './hotel-brand-wizard/hotel-brand-wizard.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    ArchwizardModule,
    HotelManagementRoutingModule
  ],
  declarations: [
    HotelBrandComponent, 
    HotelsListComponent, 
    HotelBrandAddComponent, 
    HotelBrandWizardComponent,
    HotelsAddComponent
  ],
  providers: [HotelManagementService, LoyaltyService],
})
export class HotelManagementModule { }



// WEBPACK FOOTER //
// ./src/app/components/admin/hca-admin/hotels/hotel-management/hotel-management.module.ts